<template>
    <div class="relative">
        <font-awesome-icon icon="search" class="icon-left search-icon z-10" />
        <input
            ref="input"
            type="search"
            class="global-search-input input"
            :placeholder="placeholder"
            name="search"
            autocomplete="off"
        >
    </div>
</template>

<script>
    import SearchAutocomplete from './SearchAutocomplete';

    export default {
        extends: SearchAutocomplete,
        computed: {
            placeholder() {
                return lang('Sök på ownit.se', 'Search ownit.se');
            },
        },
        mounted() {
            EventBus.$on('global-search-opened', () => {
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
            });

            this.setup();
        },
    };
</script>
